// Shared by the button and link presentations so the two cannot drift. Each
// label sits next to the tooltip that explains it, so a copy change cannot
// leave the two describing different things.
//
// A successful add either auto-accepts (the carrier becomes a partner right
// away) or leaves the invite awaiting the carrier's response, depending on the
// carrier's own network slots. Shippers have no visibility into carrier slots
// and nothing to do about them, so both outcomes are reported the same way: an
// invite was sent. Where it auto-accepted, the refreshed partner state is what
// tells the shipper the carrier is now a partner.
export const ADD_PARTNER_COPY = {
  actionable: {
    label: "Add Partner",
    tooltip: "Add this carrier to your partner network",
  },
  failed: {
    label: "Add Partner failed - retry",
    tooltip: "The carrier was not added. Click to try again",
  },
  inviteSent: {
    label: "Invite Sent",
    tooltip: "Waiting for this carrier to accept your partner invite",
  },
} as const;

export const ADD_PARTNER_SUCCESS_MESSAGE =
  "Partner invite sent to this carrier.";

export const ADD_PARTNER_ERROR_FALLBACK =
  "Failed to add carrier as partner. Please try again.";
